import React from "react";
import { useSelector } from "react-redux";
import { Image } from "react-bootstrap";

import { getUserState } from "../../app/selector";

import ProfileInformation from "./ProfileInformation";
import ProfilePicture from "./ProfilePicture";

import homepage from "../../resources/Homepage.jpeg";

const Profile = () => {
  const { loggedIn } = useSelector(getUserState);

  if (!loggedIn) {
    return (
      <div className="content-block  bg-light p-3 rounded">
        <Image
          src={homepage}
          alt="Homepage"
          fluid
          className="homepage-image"
        />
      </div>
    );
  }

  return (
    <div className="content-block bg-light p-3 rounded">
      <div className="profile">
        <ProfilePicture />
        <ProfileInformation />
      </div>
    </div>
  );
};

export default Profile;